import React, { useState } from 'react';

function NumberInput(props) {
    const { value, ...propList } = props;

    return (<input type='number' {...propList} value={Number(value).toString()} />);
}

export default NumberInput;